<template>
    <b-col v-bind="$props">
        <slot />
    </b-col>
</template>

<script>
import { BCol } from 'bootstrap-vue'

export default {
    components: { BCol },
    props: {
        cols: { type: [Number, String], default: null },
        'align-self': { type: String, default: null }
    }
}
</script>